import { UserManager, WebStorageStateStore } from 'oidc-client';
import { loadPasswordlessUser } from 'shared/redux/passwordlessOidcSlice';

const authority = process.env.REACT_APP_NOPASSWORD_AUTHORITY;
const userManagerConfig = {
  authority,
  client_id: process.env.REACT_APP_NOPASSWORD_CLIENT_ID,
  response_type: 'code',
  scope: 'openid profile email',
  redirect_uri: process.env.REACT_APP_NOPASSWORD_REDIRECT,
  post_logout_redirect_uri: process.env.REACT_APP_NOPASSWORD_LOGOUT_REDIRECT,
  automaticSilentRenew: true,
  stateStore: new WebStorageStateStore({ prefix: 'pwl.' }),
};

class UserManagerPasswordless extends UserManager {
  constructor(settings = {}) {
    super(settings);
  }
}

let userManager;

const init = async (store) => {
  userManager = new UserManagerPasswordless(userManagerConfig);

  try {
    await loadPasswordlessUser(store, userManager);
  } catch (err) {
    console.warn('Error loading user', err);
  }
};
// Log.logger = console;
// Log.level = Log.DEBUG;

export const UserPasswordlessManager = {
  instance: () => userManager,
  init,
};
